import { requests } from './agent'

export const MeetingTypeTemplateAgent = {
  getTemplates: () => {
    return requests.get('/1_0/meeting-type-templates/list')
  },
}
